<template>
    <div>
        <DFormRow
            :label="__('products.productPrices.form.contract_term')"
            :is-required="true"
            :error="errors.contract_term"
        >
            <DInput
                :id="`contract_term${idSuffix}`"
                :model-value="contractTerm"
                type="number"
                min="0"
                max="127"
                @update:modelValue="$emit('update:contractTerm', $event)"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.productPrices.form.contract_term_unit')"
            :is-required="true"
            :error="errors.contract_term_unit"
        >
            <DSelect
                :id="`contract_term_unit${idSuffix}`"
                :model-value="contractTermUnit"
                :options="unitOptions"
                @update:modelValue="$emit('update:contractTermUnit', $event)"
            />
        </DFormRow>
    </div>
</template>

<script>
export default {
    name: 'ContractTerm',
    props: {
        contractTerm: {
            type: [String, Number],
            default: null
        },
        contractTermUnit: {
            type: [String, Number],
            default: null
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        contractTermUnits: {
            type: Array,
            default: () => { return [] }
        },
        idSuffix: {
            type: String,
            default: ''
        }
    },
    emits: ['update:contractTerm', 'update:contractTermUnit'],
    computed: {
        unitOptions () {
            return [{ label: '', value: '' }, ...this.contractTermUnits]
        }
    }
}
</script>
